/**
 * Keep GFM tables inside a JAN chat bubble.
 *
 * The bubble is shrink-to-fit, so a wide table paints past its background.
 * Wrapping the table lets the bubble stay capped. Header text is copied onto
 * each cell so a narrow bubble can stack the row instead of scrolling.
 */
export function wrapMarkdownTables(html: string): string {
  if (!html.includes("<table")) return html;

  return html.replace(/<table\b[^>]*>[\s\S]*?<\/table>/gi, (table) => {
    return `<div class="jan-table">${addCellLabels(table)}</div>`;
  });
}

function addCellLabels(tableHtml: string): string {
  const header = tableHtml.match(/<thead\b[^>]*>[\s\S]*?<\/thead>/i);
  if (!header) return tableHtml;

  const labels = [...header[0].matchAll(/<th\b[^>]*>([\s\S]*?)<\/th>/gi)].map(
    (match) =>
      match[1]
        .replace(/<[^>]+>/g, "")
        .replace(/\s+/g, " ")
        .trim()
  );
  if (labels.length === 0) return tableHtml;

  return tableHtml.replace(/<tbody\b[^>]*>[\s\S]*?<\/tbody>/gi, (tbody) =>
    tbody.replace(/<tr\b[^>]*>[\s\S]*?<\/tr>/gi, (row) => {
      let column = 0;
      return row.replace(/<td\b([^>]*)>/gi, (open, attrs: string) => {
        const label = labels[column++] ?? "";
        if (!label || /\bdata-label=/.test(attrs)) return open;
        const safe = label.replace(/&/g, "&amp;").replace(/"/g, "&quot;");
        return `<td${attrs} data-label="${safe}">`;
      });
    })
  );
}
